import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ChestItem from '@/roc/effects/Production/ChestItem';

const Astronomer = {
  id: '84',
  name: 'Astronomer',
  width: 3,
  height: 2,
  type: BuildingType.COLLECTABLE,
  era: 'stoneAge',
  icon: 'Astronomer',
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Astronomer',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerLevel([
        100, 125, 150, 175, 200, 225, 250, 275, 300, 325,
        350, 375, 400, 425, 450, 475, 500, 525, 550, 575,
        600, 625, 650, 675, 700, 725, 750, 775, 800, 825,
        850, 875, 900, 925, 950, 975, 1000, 1025, 1050, 1075
      ]),
      CultureRange.asFlat(3),
    ),
    new ProductionQueue(
      ProductionWorkforce.asCallbackWithLevel(
        (level) => {
          if (level < 10) {
            return 2;
          }
          if (level < 20) {
            return 3;
          }
          if (level < 30) {
            return 4;
          }
          return 5;
        }
      ),
      [
        ProductionCost.asCallbackWithLevel(
          (level) => {
            if (level <= 9) {
              return 2;
            }
            if (level <= 19) {
              return 3;
            }
            if (level <= 29) {
              return 4;
            }
            if (level <= 39) {
              return 5;
            }
            return 6;
          }
        ).withCurrency(ProductionCurrency.CURRENT_ERA_SECONDARY_GOODS),
      ],
      ProductionDuration.asFlat(8 * 60 * 60),
      ProductionOutput.asFlat(1)
        .withOutput(ProductionOutputType.CHEST)
        .withItems([
          ChestItem
            .asCallbackWithLevel(
              (level) => {
                if (level <= 10) {
                  return [1.5, 2, 2.5, 3, 3.5, 3.8, 4.05, 4.2, 4.35, 4.65][level - 1];
                }

                return 5 + (level - 11);
              }
            )
            .withChance(1)
            .withOutput(ProductionOutputType.RESEARCH_POINTS)
          ,
        ])
      ,
    ),
  ]),
};

export default Astronomer;
